export default "__VITE_ASSET__qLaT$rZY__"